module.exports = __webpack_public_path__ + "static/media/others3.fda49984.png";